// import React, { useState } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   CircularProgress,
//   Link,
// } from "@mui/material";
// import axios from "axios";
// import { API_BASE_URL } from "../../config";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";


// // Password rules: Min 8 chars, 1 uppercase, 1 special char
// const passwordRules = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

// export const ResetPassword = ({ email, onBackToLogin }) => {
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const formik = useFormik({
//     initialValues: { code: "", password: "" },
//     validationSchema: Yup.object({
//       code: Yup.string().required("Code is required"),
//       password: Yup.string()
//         .matches(
//           passwordRules,
//           "Min 8 chars, one uppercase, one special char"
//         )
//         .required("Required"),
//     }),
//     onSubmit: async (values) => {
//       setLoading(true);
//       try {
//         await axios.post(`${API_BASE_URL}/auth/reset-pass/`, {
//           email,
//           otp: values.code,
//           new_password: values.password,
//         });

//         setSnackbar({
//           open: true,
//           message: "Password reset successful!",
//           severity: "success",
//         });

//         setTimeout(() => {
//           setSnackbar({ open: false });
//           onBackToLogin(); // Go to login form
//         }, 1200);
//       } catch (err) {
//         setSnackbar({
//           open: true,
//           message: err?.response?.data?.message || "Reset password failed",
//           severity: "error",
//         });
//       } finally {
//         setLoading(false);
//       }
//     },
//   });

//   const handleCloseSnackbar = (_, reason) => {
//     if (reason === "clickaway") return;
//     setSnackbar((s) => ({ ...s, open: false }));
//   };

//   return (
//     <>
//       <Typography
//         variant="h5"
//         fontWeight="bold"
//         gutterBottom
//         textAlign="center"
//       >
//         Reset Password
//       </Typography>

//       <Box
//         component="form"
//         onSubmit={formik.handleSubmit}
//         sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//       >
//         <TextField
//           label="Email"
//           name="email"
//           size="small"
//           value={email}
//           disabled
//           fullWidth
//         />

//         <TextField
//           label="Code"
//           name="code"
//           size="small"
//           value={formik.values.code}
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           error={formik.touched.code && Boolean(formik.errors.code)}
//           helperText={formik.touched.code && formik.errors.code}
//           fullWidth
//           required
//         />

//         <TextField
//           label="New Password"
//           name="password"
//           size="small"
//           type="password"
//           value={formik.values.password}
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           error={formik.touched.password && Boolean(formik.errors.password)}
//           helperText={formik.touched.password && formik.errors.password}
//           fullWidth
//           required
//         />

//         <Button
//           type="submit"
//           variant="contained"
//           fullWidth
//           disabled={loading}
//           startIcon={loading ? <CircularProgress size={20} /> : null}
//         >
//           {loading ? "Resetting..." : "Reset Password"}
//         </Button>

//         <Typography variant="body2" align="center" sx={{ mt: 1 }}>
//           <Link
//             underline="hover"
//             sx={{ cursor: "pointer" }}
//             onClick={onBackToLogin}
//           >
//             Back to Login
//           </Link>
//         </Typography>
//       </Box>

//       {/* Custom Snackbar */}
//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={handleCloseSnackbar}
//       />
//     </>
//   );
// };



import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Link,
} from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import { useTranslation } from "react-i18next";

// Password rules: Min 8 chars, 1 uppercase, 1 special char
const passwordRules = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

export const ResetPassword = ({ email, onBackToLogin }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const formik = useFormik({
    initialValues: { code: "", password: "" },
    validationSchema: Yup.object({
      code: Yup.string().required(t("reset.errors.codeRequired")),
      password: Yup.string()
        .matches(passwordRules, t("reset.errors.passwordRules"))
        .required(t("reset.errors.passwordRequired")),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        await axios.post(`${API_BASE_URL}/auth/reset-pass/`, {
          email,
          otp: values.code,
          new_password: values.password,
        });

        setSnackbar({
          open: true,
          message: t("reset.success"),
          severity: "success",
        });

        setTimeout(() => {
          setSnackbar({ open: false });
          onBackToLogin(); // Go to login form
        }, 1200);
      } catch (err) {
        setSnackbar({
          open: true,
          message: err?.response?.data?.message || t("reset.errors.failure"),
          severity: "error",
        });
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((s) => ({ ...s, open: false }));
  };

  return (
    <>
      <Typography
        variant="h5"
        fontWeight="bold"
        gutterBottom
        textAlign="center"
      >
        {t("reset.heading")}
      </Typography>

      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        <TextField
          label={t("reset.fields.email")}
          name="email"
          size="small"
          value={email}
          disabled
          fullWidth
        />

        <TextField
          label={t("reset.fields.code")}
          name="code"
          size="small"
          value={formik.values.code}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.code && Boolean(formik.errors.code)}
          helperText={formik.touched.code && formik.errors.code}
          fullWidth
          required
        />

        <TextField
          label={t("reset.fields.newPassword")}
          name="password"
          size="small"
          type="password"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          fullWidth
          required
        />

        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? t("reset.buttons.resetting") : t("reset.buttons.reset")}
        </Button>

        <Typography variant="body2" align="center" sx={{ mt: 1 }}>
          <Link
            underline="hover"
            sx={{ cursor: "pointer" }}
            onClick={onBackToLogin}
          >
            {t("reset.backToSignin")}
          </Link>
        </Typography>
      </Box>

      {/* Custom Snackbar */}
      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </>
  );
};
